import React from 'react'
import { CardActions, CardContent, Divider, Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import jMoment from 'moment-jalaali';
import RonadIcons from '../iconComponent';
const useStyles = makeStyles(theme =>
  createStyles({
    card: {
      width: '50%',
      boxShadow: 'none !important',
      border: '1px solid lightgray',
      marginBottom: '8px',
    },
    adminCard: {
      width: '50%',
      boxShadow: 'none !important',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#2F4858",
      color: "#fff",
      justifySelf: "end",
      borderTopRightRadius: "0px",
    },
    userCard: {
      width: '50%',
      boxShadow: 'none !important',
      border: '1px solid lightgray',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#fff",
      borderTopLeftRadius: "0px",
    },
    container: {
      display: "grid",
      width: "100%",
    },
    userName: {
      margin: "5px",
      fontWeight: 700
    },
    adminUserName: {
      margin: "5px",
      fontWeight: 700,
      textAlign: "right"
    },
    adminDate: {
      textAlign: "right"
    }
  })
);



const TicketCards = (props) => {

  const classes = useStyles();


  return (
    <div className={classes.container}>
      <Typography className={props.data?.fromUser ? classes.userName : classes.adminUserName}>
        {props.data?.userName}
      </Typography>
      <Card className={props.data?.fromUser ? classes.userCard : classes.adminCard}>
        <CardContent style={{ padding: '16px' }}>
          <Typography>
            {props.data?.message}
          </Typography>
        </CardContent>
        {props.data.attachments.length > 0 &&
          <>

            <Divider />
            <CardActions>
              <Typography>

                {
                  props.data?.attachments.map((item) => {
                    return (
                      <>
                        <a style={{ textDecoration: 'none' }} target="_blank" href={`${item}`}  >{item.split('/').pop()}</a>
                        <RonadIcons name='fileShare' size={0.8} style={{ marginLeft: '8px' }} />
                      </>
                    )

                  })
                }
              </Typography>
            </CardActions>
          </>
        }
      </Card >
      <Typography className={!props.data?.fromUser && classes.adminDate}>
        {jMoment(props.data?.dateTime, 'YYYY-M-D HH:mm')
          .locale('fa')
          .format('HH:mm jYYYY/jMM/jDD ')}
      </Typography>
    </div>
  )
}

export default TicketCards